import { render, staticRenderFns } from "./MasonryLayout.vue?vue&type=template&id=4ea2c77a&"
import script from "./MasonryLayout.vue?vue&type=script&lang=js&"
export * from "./MasonryLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports